<div class="container">
  <mat-toolbar class="title-toolbar">
    <span>
      <h3>Datastore Settings</h3>
    </span>

    @if (allowAdd) {
      <button
        mat-flat-button
        color="primary"
        (click)="openDialogAddEdit('add')">
        New Datastore Property
      </button>
    }
  </mat-toolbar>

  <mat-card class="table-card mat-elevation-z0">
    <mat-card-content class="card-content">
      <mat-table
        #table
        [dataSource]="datasource"
        matSort
        matSortActive="moduleName"
        matSortDirection="asc">
        <!--Module Column -->
        <ng-container matColumnDef="moduleName">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Module</mat-header-cell
          >
          <mat-cell *matCellDef="let row"> {{ row.moduleName }} </mat-cell>
        </ng-container>

        <!-- Property Column -->
        <ng-container matColumnDef="displayName">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Setting
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="wrapper">
              <span>{{ row.displayName }}</span>
              <mat-icon
                [matTooltip]="row.description"
                matTooltipPosition="right"
                matTooltipClass="ds-description-tooltip">
                <span class="material-symbols-outlined"> info </span>
              </mat-icon>
            </div>
          </mat-cell>
        </ng-container>

        <!-- For Property Value Column -->
        <ng-container matColumnDef="propertyValue">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Value
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.propertyValue }} </mat-cell>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              (click)="openDialogAddEdit('edit', row)">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </mat-card-content>
  </mat-card>
  <mat-divider></mat-divider>
  <mat-paginator
    #paginator
    class="paginator"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20]"
    [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<ng-template
  #dialogAddTpl
  let-data>
  <h5
    class="datastoreprops-title"
    mat-dialog-title>
    {{ data.actions === "add" ? "New" : "Edit" }} Datastore Setting
  </h5>
  <mat-dialog-content
    class="datatoreprops-dialog-content"
    [formGroup]="datastorePropsForm">
    <mat-form-field>
      <mat-label>Module</mat-label>
      <input
        type="text"
        matInput
        formControlName="moduleName" />
      <mat-error *ngIf="datastorePropsForm.get('moduleName')?.hasError('required')"> Required </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Setting</mat-label>
      <input
        type="text"
        matInput
        formControlName="property" />
      <mat-error *ngIf="datastorePropsForm.get('property')?.hasError('required')"> Required </mat-error>
      <mat-error *ngIf="datastorePropsForm.get('property')?.hasError('propertyExists')">
        Property already exists
      </mat-error>
    </mat-form-field>
    @switch (datastorePropsForm.get("type")?.value) {
      @case ("NUMBER") {
        <mat-form-field>
          <mat-label>Value</mat-label>
          <input
            type="number"
            matInput
            formControlName="propertyValue" />
          @if (datastorePropsForm.errors) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
      }
      @case ("LIST") {
        <mat-form-field>
          <mat-label>Value</mat-label>
          <mat-select
            formControlName="propertyValue"
            [multiple]="true">
            <div class="search-container">
              <mat-form-field>
                <mat-label>Search</mat-label>
                <input
                  matInput
                  type="text"
                  id="select-search"
                  (keyup)="filterOptions($event)" />
              </mat-form-field>
            </div>
            @for (option of filteredOptions; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-select>
          @if (datastorePropsForm.errors) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
      }
      @case ("BOOLEAN") {
        <mat-checkbox formControlName="propertyValue">{{
          datastorePropsForm.get("propertyValue").value ? "Enabled" : "Disabled"
        }}</mat-checkbox>
      }
      @default {
        <mat-form-field>
          <mat-label>Value</mat-label>
          <input
            type="text"
            matInput
            formControlName="propertyValue" />
          @if (datastorePropsForm.errors) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close>
      Cancel
    </button>

    <button
      [disabled]="datastorePropsForm.invalid || (loaders$ | async)?.dsPropMutation"
      mat-flat-button
      color="primary"
      (click)="addEditDatastoreProperty(data.actions)">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>
